import { CustomerDataChangeDTO, ICustomerNumberInfo, parseCustomerDataChangeItemDTO } from '../customer/customer.model';
import { IBulletConfirmationStatusChangeResponse, IILAdresse } from '../integrationlayer/api.model';
import { IKontaktDetails, IOrganisation, IPhysischePerson } from '../integrationlayer/customer.model';

export interface PartnerDataChangeDTO {
  geschaeftsPartnerId: string;
  geschaeftsPartnerArt: string;
  customerData: ICustomerNumberInfo;
  physischePerson?: IPhysischePerson;
  organisation?: IOrganisation;
  adresse?: IILAdresse[];
  kontaktdetails?: IKontaktDetails[];
  orderedAt?: string;
}

export interface PartnerDataChangeStatusResponse {
  changeData: string;
  responseData?: string;
  collaborationMode: 'Y' | 'N';
  correlationId: string;
  createdAt: string;
  errorCode?: string;
  processStatus: string;
  version: 'V1' | 'V2';
}

// tslint:disable-next-line:no-empty-interface
export type IPartnerDataChangeResponse = IBulletConfirmationStatusChangeResponse;

export function isPartnerDataChangeDTO(object: object): object is PartnerDataChangeDTO {
  return (
    'customerData' in object &&
    ('physischePerson' in object || 'organisation' in object || 'adresse' in object || 'kontaktdetails' in object)
  );
}

export const parsePartnerDataChangeItemDTO = (
  orderDetail: PartnerDataChangeStatusResponse,
): PartnerDataChangeDTO | CustomerDataChangeDTO => {
  if (!orderDetail) {
    return null;
  }
  const orderData = JSON.parse(orderDetail.changeData);
  const responseData = orderDetail.responseData ? JSON.parse(orderDetail.responseData) : undefined;
  if (orderDetail.version === 'V2') {
    const physischePerson = { ...orderData.physischePerson, ...responseData?.geschaeftsPartner?.physischePerson };
    const organisation = { ...orderData.organisation, ...responseData?.geschaeftsPartner?.organisation };
    return {
      geschaeftsPartnerArt: orderData.geschaeftsPartnerArt,
      geschaeftsPartnerId: orderData.geschaeftsPartnerId,
      customerData: orderData.customerData,
      physischePerson: physischePerson,
      organisation: organisation,
      adresse: orderData.adresse,
      kontaktdetails: orderData.kontaktdetails,
      orderedAt: orderDetail.createdAt,
    };
  } else {
    return parseCustomerDataChangeItemDTO(orderDetail);
  }
};
